<template>
    <base-component>
        <template slot="form">
            <dealer-search-form :fetch="fetchData" :pageSize="pageSize" :offset="offset" :setOffset="setOffset"/>
        </template>
        <template slot="createButton">
            <b-button v-if="isOperator && !showCreateDealer" @click="toggleCreateDealer" variant="primary">
                <account-plus-icon title="" />&nbsp;{{ $t('general.add') }}
            </b-button>
        </template>
        <template slot="createForm">
            <dealer-create-form v-if="showCreateDealer" :on-created="fetchData" :close-form="toggleCreateDealer" />
        </template>
        <template slot="workArea">
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>
            <b-card class="flex-fill flex-shrink-0">
                <pagination :pageSize="this.pageSize" :offset="offset" :listLength="dealers.length" :setOffset="setOffset"/>
                <b-table :items="dealers" :fields="fields" class="table-borderless" striped small show-empty>
                    <template slot="registrationDate" slot-scope="row">
                        {{ $d(new Date(row.item.registrationDate), 'long') }}
                    </template>
                    <template slot="action" slot-scope="row">
                        <b-dropdown variant="link">
                            <template slot="button-content">
                                <dots-icon title="" />
                            </template>
                            <b-dd-item v-show="isOperator" @click.stop="openEditDealerModal(row)">{{ $t('general.edit') }}</b-dd-item>
                            <b-dd-item :to="{
                                    name: 'childKkm',
                                    params: Object.assign({ dealerId: row.item.id }, row.item)
                                }">
                                {{ $t('menu.kkms') }}
                            </b-dd-item>
                            <b-dd-item v-if="isInspector" :to="{
                                    name: 'childReports',
                                    params: Object.assign({ dealerId: row.item.id }, row.item)
                                }">
                                {{ $t('menu.reports') }}
                            </b-dd-item>
                            <b-dd-item v-if="isInspector" :to="{
                                    name: 'childTickets',
                                    params: Object.assign({ dealerId: row.item.id }, row.item)
                                }">
                                {{ $t('menu.tickets') }}
                            </b-dd-item>
                            <b-dd-item v-if="isInspector" :to="{
                                    name: 'childMoneyPlacements',
                                    params: Object.assign({ dealerId: row.item.id }, row.item)
                                }">
                                {{ $t('menu.moneyPlacements') }}
                            </b-dd-item>
                            <b-dd-item v-if="isInspector" :to="{
                                    name: 'childTasks',
                                    params: Object.assign({ dealerId: row.item.id }, row.item)
                                }">
                                {{ $t('menu.tasks') }}
                            </b-dd-item>
                        </b-dropdown>
                    </template>
                    <template slot="empty">
                        <div class="text-center">
                            {{ $t('general.noData') }}
                        </div>
                    </template>
                </b-table>
                <b-modal ref="editDealerModal" :title="$t('menu.editDealer')" hide-footer lazy>
                    <dealer-edit-form :dealer-id="clickedDealer.id" />
                </b-modal>
            </b-card>
        </template>
    </base-component>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata'
const DealerSearchForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/dealer/DealerSearchForm.vue')
const DealerCreateForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/dealer/DealerCreateForm.vue')
const DealerEditForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/dealer/DealerEditForm.vue')
const Pagination = () => import(/* webpackChunkName: "chunk-views" */ '@/components/general/Pagination.vue')

export default {
    name: 'dealers',
    mixins: [ AppData ],
    components: {
        DealerSearchForm,
        DealerCreateForm,
        DealerEditForm,
        Pagination
    },
    data () {
        return {
            showAlert: false,
            alert: '',
            showCreateDealer: false,
            dealers: [],
            clickedDealer: {},
            pageSize: 20,
            offset: 0
        }
    },
    computed: {
        fields() {
            return [
                { key: 'id', label: 'ID', sortable: true },
                { key: 'registrationDate', label: this.$t('dealer.regDateTime') },
                { key: 'name', label: this.$t('dealer.name'), sortable: true },
                { key: 'industry', label: this.$t('dealer.industry'), sortable: true },
                { key: 'iin', label: this.$t('general.iinbin') },
                { key: 'action', label: this.$t('general.actions') }
            ];
        },
        isOperator() {
            return this.$store.getters.getUserRole === this.$appConfig.role.operator;
        }
    },
    methods: {
        fetchData(formData) {
            this.hideAlert();

            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.dealer.getAll,
                formData,
                this.onResponse,
                this.displayAlert);
        },
        onResponse(result) {
            this.dealers = result;
        },
        hideAlert() {
            this.showAlert = false;
            this.alert = '';
        },
        displayAlert(errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`);
            this.showAlert = true;
        },
        toggleCreateDealer() {
            this.hideAlert();
            this.showCreateDealer = !this.showCreateDealer;
        },
        openEditDealerModal(row) {
            this.clickedDealer = row.item;
            this.$refs.editDealerModal.show();
        },
        setOffset(newValue) {
            this.offset = newValue;
        }
    }
}
</script>
